export default __webpack_public_path__ + "static/media/14c-2x.49a5fe48.png";